import { SubscriptionLoadingProcessor } from '@core/components/ServerSideEvents';
import { Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from '@material-ui/core';
import { AnexoUnico } from 'app/components/Anexo';
import { CircularProgressWithLabel } from 'app/components/LoadingProgress';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';

const ArquivoRetornoForm = ({ listener, setListener, uuidLeitura }) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 7;

  const formikContext = useFormikContext();

  const { values, handleChange, errors, touched, submitCount } = formikContext;

  const _errors = {
    arquivo: (submitCount > 0 || touched?.arquivo) && errors?.arquivoNome,
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onFileChange = (event) => {
    handleChange({
      target: {
        id: 'arquivo',
        value: event.target.files[0],
      },
    });

    handleChange({
      target: {
        id: 'arquivoNome',
        value: event.target.files[0].name,
      },
    });
  };

  const config = {
    onmessage: (event) => {
      const progress = JSON.parse(event.data);
      
      handleChange({
        target: {
          id: 'progress',
          value: progress,
        },
      });

      if (progress === 100) {
        setListener(false);
      }
    },
    onerror: (err) => {
      console.error('EventSource failed:', err);
      setListener(false);
    },
  };

  return (
    <SubscriptionLoadingProcessor connect={listener} eventSourceConfig={config} codigoSuporte={uuidLeitura}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <AnexoUnico
            placeholder="Selecione o arquivo retornado pelo banco"
            onFileChange={onFileChange}
            arquivo={values.arquivo}
            accept=".RET"
            error={_errors.arquivo}
            helperText={_errors.arquivo}
            touched={!!_errors.arquivo}
          />
        </Grid>

        {listener && (
          <Grid item xs={12} style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <CircularProgressWithLabel value={values.progress} size={60} />
          </Grid>
        )}

        {values.registroOcorrencia && values.registroOcorrencia.length > 0 && (
          <Grid item xs={12}>
            <Typography>Ocorrências retornadas pelo banco</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Nosso número</TableCell>
                  <TableCell align="left">Ocorrência</TableCell>
                  <TableCell align="left">Motivo</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {values.registroOcorrencia
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((registro) => {
                    return (
                      <TableRow>
                        <TableCell align="left">{registro.nossoNumero}</TableCell>
                        <TableCell align="left">{registro.descricaoOcorrencia}</TableCell>
                        <TableCell align="left">{registro.descricaoMotivo}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>

            {values.registroOcorrencia.length > rowsPerPage && (
              <TablePagination
                component="div"
                className="pb-0"
                count={values.registroOcorrencia.length}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage={false}
                page={page}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                onChangePage={handleChangePage}
                rowsPerPageOptions={[]}
              />
            )}
          </Grid>
        )}
      </Grid>
    </SubscriptionLoadingProcessor>
  );
};

export default ArquivoRetornoForm;
